import { HttpError } from '@forto-dev/ui-platform-http'

import { useLocalisation } from '@/utils/localisation'

export const getErrorMessage = (error: unknown, translate: ReturnType<typeof useLocalisation>['translate']): string => {
  if (error instanceof HttpError) {
    if (error.status === 404) {
      return translate('notifications.cancel_shipment.notifications.error.shipment_not_found')
    }
    const message = (error.responseData as { message?: string } | undefined)?.message
    if (message) return message
  }
  return translate('notifications.cancel_shipment.notifications.error.generic')
}
